/**
 * Hospitalisations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import  _ from 'lodash';

// States
const state = {
    uploadFile: {}
};

// Getters
const getters = {
    uploadFile: state => {
        return state.uploadFile
    }
};

// Actions
const actions = {
    deleteUploadFile(context, payload) {
        function successCallback(response) {
            let uploadFiles = _.filter(response.data.file.fileable.files,function (file) {
                return file.id != response.data.file.id;
            })
            context.commit('updateMedecineGeneralFileHandler', { files:uploadFiles});
            context.commit('updateCardiologyCardiologyFileHandler', { files:uploadFiles});
            context.commit('updateManuscritFileHandler', { files:uploadFiles});

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
         }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.File.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

};

// Mutations
const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}